export default __webpack_public_path__ + "locales/lo-LA/FormGallery.json?hash=c15af5579003aaa9beec136a853c80e6";